import React, { FC } from 'react';
import { Card, Container, Grid } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { DashboardHeader } from 'src/UIKit/DashboardHeader';
import { useNotificationCreation } from '../../presenters/useNotificationCreation';
import { ResponsiveDateTimePickers } from '../components/responsiveDateTimePicker';
import { TextInput } from 'src/UIKit/TextInput';
import { observer } from 'mobx-react';
import { ResourceFile } from 'src/modules/resources/ui/components/resourceFile';
import { Select } from 'src/UIKit/Select';

export const NotificationCreationView: FC = observer(() => {
    const { t } = useUiContext();
    const { onCreateNotification, time, checked, onChangeSwitch, onChangeTime, onAcceptTime, onChange, notification, resource, onChangeFile, IMAGE_TYPES,
        typeObject, errors
    } = useNotificationCreation(); 

    return (
        <Container maxWidth="xl">
            <DashboardHeader title={t('notifications.newNotification')} buttonTitle={t('notifications.createNotification')} onPress={onCreateNotification} />
            <Grid item mb={5}>
                <Card sx={{ p: 2, mb: 2 }}>
                    <TextInput label={t('notifications.title') + "*"} name='title' onChange={onChange} value={notification?.title} error={errors}/>
                    <TextInput label={t('notifications.text') + "*"} name='body' onChange={onChange} value={notification?.body} error={errors} isMultiline rows={3}/>
                    <Select label={t('notifications.image')} name='type' onChange={onChange} value={typeObject?.name || ''} options={IMAGE_TYPES}/>
                    {notification?.type === 'LINK_IMAGE' ? 
                    <TextInput label={t('notifications.imageUrl')} name='image' onChange={onChange} value={notification?.image} />
                    : <ResourceFile item={resource} onChange={onChangeFile} />}
                    <TextInput label={t('notifications.link')} name='navigation_url' onChange={onChange} value={notification?.navigation_url} />
                </Card>
                <ResponsiveDateTimePickers time={time} checked={checked} onChangeSwitch={onChangeSwitch} onChangeTime={onChangeTime} onAcceptTime={onAcceptTime}/>
            </Grid>
        </Container>
    );
});
